import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=ba8d4e36&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=ba8d4e36&lang=scss&scoped=true&"
import style1 from "./settings.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./settings.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8d4e36",
  null
  
)

export default component.exports